import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d9mtdukit35ii3jdllng';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');

    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim()) {
      setStatus('success');
      setMessage('感谢订阅！我们会为您推送最新追剧资讯。');
      setEmail('');
      return;
    }

    try {
      const formData = new FormData(form);
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, value as string);
      });

      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      const code = parsed?.code as string | undefined;

      if (res.ok && code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！我们会为您推送最新追剧资讯。');
        setEmail('');
      } else {
        const meta = parsed?.meta as { message?: string; detail?: string } | undefined;
        const serverMsg = meta?.message || meta?.detail || responseText || '';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('success');
          setMessage('感谢订阅！我们会为您推送最新追剧资讯。');
          setEmail('');
        } else {
          setStatus('error');
          setMessage(serverMsg || '订阅失败，请稍后重试。');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后重试。');
    }
  };

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-[800px] mx-auto px-4 md:px-6 lg:px-8 text-center">
        <div className="rounded-2xl bg-gradient-to-br from-background-100 via-background-100 to-primary-500/5 border border-background-200/60 p-8 md:p-12">
          <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-5 rounded-2xl bg-primary-500/10">
            <i className="ri-mail-send-line text-2xl md:text-3xl text-primary-400"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 mb-3">
            订阅追剧资讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-6 max-w-md mx-auto">
            第一时间获取最新剧集上线通知和独家追剧攻略
          </p>

          <form onSubmit={handleSubmit} data-readdy-form="" className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto">
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="antispam-field" />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入您的邮箱地址"
              required
              className="flex-1 w-full sm:w-auto px-4 py-3 rounded-lg bg-background-50 border border-background-300/60 text-foreground-100 text-sm placeholder-foreground-500 focus:outline-none focus:border-primary-500/50 focus:ring-1 focus:ring-primary-500/30 transition-all duration-300"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full sm:w-auto px-6 py-3 rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {status === 'loading' ? '提交中…' : '立即订阅'}
            </button>
          </form>

          {status === 'success' && (
            <p className="mt-4 text-sm text-primary-400 animate-fade-in">{message}</p>
          )}
          {status === 'error' && (
            <p className="mt-4 text-sm text-accent-500 animate-fade-in">{message}</p>
          )}
        </div>
      </div>
    </section>
  );
}